import React from "react";
import { Link } from "react-router-dom";
import Button from "../../../../../../components/common/Button";
import QuestionItem from "./QuestionItem";
import AutoFillButton from "../../../../../../components/autoFill/AutoFillButton";

const subFolderModules = ["repository"];

export default function SectionRenderer({
    module,
    currentSection,
    // State
    section,
    refresh,
    loading,
    isSaving,
    questionsAndAnswersToSave,
    attachment,
    visibleSection,
    isFAMenuVisible,
    deleteFile,
    dateValue,
    additionalSections,
    isSectionNameDuplicate,
    reportGenerateLoading,
    hasAgreedAiReportDisclaimer,
    // Handlers
    saveAnswer,
    radioButtonChanged,
    handleFileChange,
    confirmDeleteFile,
    syncDrive,
    syncDropbox,
    syncSharePoint,
    generateInsuranceAiReport,
    handleSectionReportLinkClick,
    setSection,
    setRefresh,
    setDeleteFile,
    setDeleteFileQuestionId,
    handleSectionLogs,
    setLogModule,
    onClickFileManager,
    answerSaved,
    getViewableURL,
    getFilesFromQuestions,
    showRiskRecommendation,
    sortQuestionsByQNo,
    getReportGenerationKey,
    hasSectionReport,
    getSectionReport,
    getSectionTabName,
    getCompletenessAndRiskHTML,
    // Redux state
    user,
    modal,
    // Parent props
    company,
    tab,
    permissionLevel,
    advisors,
    companyId,
    openKPI,
    isTwoMinuteTesHomePage,
    sortSections,
    aiEnhanced,
    setAiEnchaned,
    onDragOver,
    onDrop,
    handleDateChange,
    // dispatch
    dispatch,
    toggleModal,
    sectionRefs,
    moduleId,
    reloadModule,
    patchAnswerInModule,
    ancestorSectionName = null,
}) {
    if (module) module = JSON.parse(JSON.stringify(module));
    if (currentSection) currentSection = JSON.parse(JSON.stringify(currentSection));
    const parentSectionName = ancestorSectionName || currentSection?.['sectionName'] || currentSection?.['name'] || null;
    let convert;
    if (module['type'].includes('directors-questionnaire')) convert = currentSection?.subFolders || module?.sections[0]?.subFolders;
    else convert = currentSection?.subFolders || module?.sections;
    const getQuestionsForNode = (node, inheritedQuestions = []) => {
        const qNo = node?.sectionNo || node?.no;
        const ownPool = Array.isArray(node?.questions) && node.questions.length > 0
            ? node.questions
            : inheritedQuestions;
        const matched = (ownPool || []).filter(q => q?.qNo === qNo);
        if (matched.length > 0) return matched;
        if (node?.question) return [node.question];
        return [];
    };

    const hasNestedRenderableContent = (node, inheritedQuestions = []) => {
        const ownQuestions = getQuestionsForNode(node, inheritedQuestions);
        const childNodes = Object.values(node?.subFolders || {});
        if (ownQuestions.length > 0) return true;
        // Expansion-pack style: section owns a flat questions array (e.g. DEPF008 with DEPF008.1, DEPF008.2…)
        if (Array.isArray(node?.questions) && node.questions.length > 0) return true;
        return childNodes.some(child => hasNestedRenderableContent(child, Array.isArray(node?.questions) ? node.questions : inheritedQuestions));
    };

    return <>
        {convert && Object.values(convert)
            .filter(s => hasNestedRenderableContent(s, currentSection?.questions || []))
            .slice().sort(sortSections).map((sectionItem, sectionIdx) => {
                if ((module['type'] == 'repository' || module['type'] == `business-audit-${company['testType']}`) && ((user['role'] == "Advisor" || user['role'] == "Investor") && (user?.['companyId'] && user?.['companyId']?.['_id'] != company?.['_id'])) && (company['advisors'] || company['investors']) && sectionItem?.['sectionNo']) {
                    // if ((company?.['advisors']?.[user['_id']]?.['modules'] && !company?.['advisors']?.[user['_id']]?.['modules']?.[sectionItem?.['sectionNo']] && user['role'] == 'Advisor' && user?.['companyId']?.['_id'] !== company['_id']) || (!company?.['investors']?.[user['_id']]?.['modules']?.[sectionItem?.['sectionNo']] && user['role'] == 'Investor')) return;

                }

                const qNo = sectionItem.sectionNo || sectionItem.no;
                const sectionId = sectionItem['_id'] || sectionItem['sectionId'] || `section-${sectionIdx}`;
                let questions;
                let showSubFolder = false;
                let subfolderGroups = null;
                if (module['expansionPack']) {
                    showSubFolder = qNo.indexOf('.') < 0;
                    questions = qNo.indexOf('.') > 0 ? sectionItem['questions'] : [];
                    sectionItem.stats = sectionItem.stats || currentSection?.stats; // Temporary
                } else if (subFolderModules.includes(module.type)) {
                    if (currentSection) sectionItem.questions = currentSection.questions;
                    showSubFolder = Object.values((sectionItem && sectionItem?.subFolders) || {}).length > 0;
                    questions = getQuestionsForNode(sectionItem, currentSection?.questions || []);
                } else if ((module.isInvestorMatch || module.isInvestmentReadiness) && sectionItem.subFolders && Object.keys(sectionItem.subFolders).length > 0) {
                    const allQuestions = sectionItem.questions || [];
                    subfolderGroups = Object.values(sectionItem.subFolders).map(sfNode => {
                        const sfNo = sfNode.sectionNo || sfNode.no;
                        const sfName = sfNode.sectionName || sfNode.name;
                        if (!sfNo) return null;
                        const escaped = sfNo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                        const re = new RegExp(`^${escaped}(\\.[0-9].*)?$`);
                        const sfQuestions = allQuestions.filter(q => q.qNo && re.test(q.qNo));
                        const completed = sfQuestions.filter(q => q.answer?.status === 'Completed' || q.answer?.status === 'Not Applicable').length;
                        const completionPercent = sfQuestions.length ? Math.round(completed / sfQuestions.length * 100) : 0;
                        return { sfNo, sfName, sfQuestions: sortQuestionsByQNo([...sfQuestions]), completionPercent };
                    }).filter(Boolean);
                    questions = allQuestions;
                } else questions = sectionItem.questions.filter(q => q.qNo.match(new RegExp(qNo + "(\.[0-9]+)|$")));

                sectionItem.files = [];
                sectionItem.files = getFilesFromQuestions(questions);
                // Sort all questions.
                questions = questions && sortQuestionsByQNo([...(questions || [])]);

                const jsx = <>
                    {subfolderGroups ? subfolderGroups.map(({ sfNo, sfName, sfQuestions, completionPercent }, groupIdx) => (
                        <div key={sfNo} id={sfNo} className="sectionWrapper bss bw2px bo31 br10px px1rem py1rem fs1rem mb1rem">
                            <div className="df mb0-5rem jcsb">
                                <h3 className="fs1rem mr0-5rem c15">
                                    <span className="fw400">Section {groupIdx + 1}: </span>{sfName}
                                </h3>
                                <span className="sectionTitle fs0-75rem c15">
                                    {sfNo}<span className="mx0-5rem"> | </span>
                                    {getCompletenessAndRiskHTML(module.type, { completionPercent, riskPercent: 0 }, sfQuestions)}
                                </span>
                            </div>
                            <div className="dg">
                                {sfQuestions.map((question, questionIdx) => (
                                    <QuestionItem
                                        key={question._id}
                                        question={question}
                                        questionIdx={questionIdx}
                                        sectionIdx={sectionIdx}
                                        section={sectionItem}
                                        qNo={sfNo}
                                        sectionId={sfNo}
                                        showSubFolder={false}
                                        module={module}
                                        isSaving={isSaving}
                                        isTwoMinuteTesHomePage={isTwoMinuteTesHomePage}
                                        reportGenerateLoading={reportGenerateLoading}
                                        aiEnhanced={aiEnhanced}
                                        setAiEnchaned={setAiEnchaned}
                                        company={company}
                                        tab={tab}
                                        user={user}
                                        saveAnswer={saveAnswer}
                                        radioButtonChanged={radioButtonChanged}
                                        syncDrive={syncDrive}
                                        syncSharePoint={syncSharePoint}
                                        syncDropbox={syncDropbox}
                                        setSection={setSection}
                                        handleSectionLogs={handleSectionLogs}
                                        setLogModule={setLogModule}
                                        onClickFileManager={onClickFileManager}
                                        generateInsuranceAiReport={generateInsuranceAiReport}
                                        handleSectionReportLinkClick={handleSectionReportLinkClick}
                                        hasSectionReport={hasSectionReport}
                                        getSectionTabName={getSectionTabName}
                                        getReportGenerationKey={getReportGenerationKey}
                                        showRiskRecommendation={showRiskRecommendation}
                                        answerSaved={answerSaved}
                                        getViewableURL={getViewableURL}
                                        setDeleteFileQuestionId={setDeleteFileQuestionId}
                                        setDeleteFile={setDeleteFile}
                                        onDragOver={onDragOver}
                                        onDrop={onDrop}
                                        handleDateChange={handleDateChange}
                                        dateValue={dateValue}
                                        dispatch={dispatch}
                                        toggleModal={toggleModal}
                                        moduleId={moduleId}
                                        reloadModule={reloadModule}
                                        ancestorSectionName={parentSectionName || sectionItem['sectionName'] || sectionItem['name']}
                                    />
                                ))}
                            </div>
                        </div>
                    )) : <>
                    {questions && questions.length > 0 && questions.map((question, questionIdx) => (
                        <QuestionItem
                            key={question._id}
                            question={question}
                            questionIdx={questionIdx}
                            sectionIdx={sectionIdx}
                            section={sectionItem}
                            qNo={qNo}
                            sectionId={sectionId}
                            showSubFolder={showSubFolder}
                            module={module}
                            isSaving={isSaving}
                            isTwoMinuteTesHomePage={isTwoMinuteTesHomePage}
                            reportGenerateLoading={reportGenerateLoading}
                            aiEnhanced={aiEnhanced}
                            setAiEnchaned={setAiEnchaned}
                            company={company}
                            tab={tab}
                            user={user}
                            saveAnswer={saveAnswer}
                            radioButtonChanged={radioButtonChanged}
                            syncDrive={syncDrive}
                            syncSharePoint={syncSharePoint}
                            syncDropbox={syncDropbox}
                            setSection={setSection}
                            handleSectionLogs={handleSectionLogs}
                            setLogModule={setLogModule}
                            onClickFileManager={onClickFileManager}
                            generateInsuranceAiReport={generateInsuranceAiReport}
                            handleSectionReportLinkClick={handleSectionReportLinkClick}
                            hasSectionReport={hasSectionReport}
                            getSectionTabName={getSectionTabName}
                            getReportGenerationKey={getReportGenerationKey}
                            showRiskRecommendation={showRiskRecommendation}
                            answerSaved={answerSaved}
                            getViewableURL={getViewableURL}
                            setDeleteFileQuestionId={setDeleteFileQuestionId}
                            setDeleteFile={setDeleteFile}
                            onDragOver={onDragOver}
                            onDrop={onDrop}
                            handleDateChange={handleDateChange}
                            dateValue={dateValue}
                            dispatch={dispatch}
                            toggleModal={toggleModal}
                            moduleId={moduleId}
                            reloadModule={reloadModule}
                            patchAnswerInModule={patchAnswerInModule}
                            ancestorSectionName={parentSectionName || sectionItem['sectionName'] || sectionItem['name']}
                        />
                    ))}
                    {showSubFolder && (
                        <div className="toggleHeight cp">
                            <div className="oh dg" style={{ cursor: "auto" }}>
                                <div></div> {/*LEAVE EMPTY DIV HERE*/}

                                <SectionRenderer
                                    module={module}
                                    currentSection={sectionItem}
                                    section={section}
                                    ancestorSectionName={parentSectionName || sectionItem['sectionName'] || sectionItem['name']}
                                    refresh={refresh}
                                    loading={loading}
                                    isSaving={isSaving}
                                    questionsAndAnswersToSave={questionsAndAnswersToSave}
                                    attachment={attachment}
                                    visibleSection={visibleSection}
                                    isFAMenuVisible={isFAMenuVisible}
                                    deleteFile={deleteFile}
                                    dateValue={dateValue}
                                    additionalSections={additionalSections}
                                    isSectionNameDuplicate={isSectionNameDuplicate}
                                    reportGenerateLoading={reportGenerateLoading}
                                    hasAgreedAiReportDisclaimer={hasAgreedAiReportDisclaimer}
                                    saveAnswer={saveAnswer}
                                    radioButtonChanged={radioButtonChanged}
                                    handleFileChange={handleFileChange}
                                    confirmDeleteFile={confirmDeleteFile}
                                    syncDrive={syncDrive}
                                    syncDropbox={syncDropbox}
                                    syncSharePoint={syncSharePoint}
                                    generateInsuranceAiReport={generateInsuranceAiReport}
                                    handleSectionReportLinkClick={handleSectionReportLinkClick}
                                    setSection={setSection}
                                    setRefresh={setRefresh}
                                    setDeleteFile={setDeleteFile}
                                    setDeleteFileQuestionId={setDeleteFileQuestionId}
                                    handleSectionLogs={handleSectionLogs}
                                    setLogModule={setLogModule}
                                    onClickFileManager={onClickFileManager}
                                    answerSaved={answerSaved}
                                    getViewableURL={getViewableURL}
                                    getFilesFromQuestions={getFilesFromQuestions}
                                    showRiskRecommendation={showRiskRecommendation}
                                    sortQuestionsByQNo={sortQuestionsByQNo}
                                    getReportGenerationKey={getReportGenerationKey}
                                    hasSectionReport={hasSectionReport}
                                    getSectionReport={getSectionReport}
                                    getSectionTabName={getSectionTabName}
                                    getCompletenessAndRiskHTML={getCompletenessAndRiskHTML}
                                    user={user}
                                    modal={modal}
                                    company={company}
                                    tab={tab}
                                    permissionLevel={permissionLevel}
                                    advisors={advisors}
                                    companyId={companyId}
                                    openKPI={openKPI}
                                    isTwoMinuteTesHomePage={isTwoMinuteTesHomePage}
                                    sortSections={sortSections}
                                    aiEnhanced={aiEnhanced}
                                    setAiEnchaned={setAiEnchaned}
                                    onDragOver={onDragOver}
                                    onDrop={onDrop}
                                    handleDateChange={handleDateChange}
                                    dispatch={dispatch}
                                    toggleModal={toggleModal}
                                    sectionRefs={sectionRefs}
                                    moduleId={moduleId}
                                    reloadModule={reloadModule}
                                    patchAnswerInModule={patchAnswerInModule}
                                />
                            </div>
                        </div>
                    )}
                    </>}
                </>;
                return (
                    <div ref={(el) => { if (sectionItem['sectionNo']) sectionRefs.current[sectionIdx] = el }} key={`${module.type}-${sectionId}-${qNo}-${sectionIdx}`} id={qNo}
                        className={(sectionItem['sectionNo'] && "sectionWrapper ") + " bss bw2px bo31 br10px px1rem py1rem fs1rem"}>
                        <div className="df mb0-5rem jcsb">
                            <div className="df aic" style={{ gap: '0.75rem', flexWrap: 'wrap' }}>
                                <h3 className="fs1rem mr0-5rem c15">
                                    <span className="fw400">{sectionItem['sectionName'] && `Section ${sectionIdx + 1}: `} </span>{sectionItem['sectionName'] || sectionItem['name']}
                                </h3>

                                <span className={(sectionItem['sectionNo'] && "sectionTitle") + " fs0-75rem c15"}>{qNo}
                                    <span className="mx0-5rem"> | </span> {getCompletenessAndRiskHTML(module.type, sectionItem.stats, questions)}
                                </span>

                                {(() => {
                                    const reportData = getSectionReport(sectionItem, false, null);
                                    const accuracyRating = reportData?.validation?.accuracyRating;
                                    const hasAccuracyRating = accuracyRating !== undefined && accuracyRating !== null && !Number.isNaN(Number(accuracyRating));

                                    return hasAccuracyRating ? (
                                        <div
                                            className="df aic jcc"
                                            style={{
                                                padding: '4px 10px',
                                                background: accuracyRating >= 7 ? '#e8f5e9' : accuracyRating >= 5 ? '#fff3e0' : '#ffebee',
                                                color: accuracyRating >= 7 ? '#1b5e20' : accuracyRating >= 5 ? '#e65100' : '#c62828',
                                                border: `1px solid ${accuracyRating >= 7 ? '#c8e6c9' : accuracyRating >= 5 ? '#ffe0b2' : '#ffcdd2'}`,
                                                borderRadius: '10px',
                                                fontWeight: '600',
                                                fontSize: '0.75rem',
                                                height: '24px',
                                                lineHeight: '1'
                                            }}
                                        >
                                            Accuracy: {accuracyRating}/10
                                        </div>
                                    ) : null;
                                })()}
                            </div>
                            {!isTwoMinuteTesHomePage && moduleId && tab === 'repository' && sectionItem?.['sectionNo'] && !sectionItem['sectionNo'].includes('.') && (
                                <AutoFillButton
                                    companyId={companyId}
                                    moduleType={tab}
                                    moduleId={moduleId}
                                    sectionCode={qNo}
                                    scope="section"
                                    scopeName={sectionItem['sectionName'] || qNo}
                                    size="small"
                                    onComplete={() => reloadModule && reloadModule(tab)}
                                />
                            )}
                            {
                                sectionItem['isPrompt'] ? (() => {
                                    // Check if section has at least one file
                                    const hasFiles = sectionItem.questions.some(q => q.answer?.files && q.answer.files.length > 0) && sectionItem?.['stats']?.['completionPercent'] === 100;
                                    const currentKey = getReportGenerationKey(sectionItem, false);
                                    const isGenerating = reportGenerateLoading === currentKey;
                                    const isAnyGenerating = reportGenerateLoading !== null;
                                    return (
                                        <div className="df aic jcc" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
                                            <button
                                                type='button'
                                                disabled={isAnyGenerating || !hasFiles}
                                                onClick={() => hasFiles ? generateInsuranceAiReport({ data: sectionItem, isQuestion: false }) : ""}
                                                className={`fs14px px1rem br20px cp c1 py0-25rem ${hasFiles && !isAnyGenerating ? 'bg3 bg3-hover' : 'bg5 c15 op50'} `}
                                                style={{ height: '40px' }}
                                                data-tooltip={hasFiles ? "" : "Complete the 100% section to generate the report"}
                                            >
                                                {isGenerating ? "Generating..." : "Generate Report"}
                                            </button>
                                            <Link
                                                onClick={(e) => {
                                                    if (isAnyGenerating) {
                                                        e.preventDefault();
                                                        return;
                                                    }
                                                    handleSectionReportLinkClick(e, sectionItem, false, null);
                                                }}
                                                to={hasSectionReport(sectionItem, false, null) ? `#${getSectionTabName(sectionItem, false, null)}` : "#repository"}
                                                className={`cp p1rem c1 ${hasSectionReport(sectionItem, false, null) && !isAnyGenerating ? 'bg3 bg3-hover' : 'bg5 c15 op50'} br50px fw400 fs14px zi0 td250 df aic jcc`}
                                                style={{ width: '40px', height: '40px', pointerEvents: isAnyGenerating ? 'none' : 'auto', cursor: isAnyGenerating ? 'not-allowed' : 'pointer' }}
                                            >
                                                R
                                            </Link>
                                        </div>
                                    );
                                })() : null
                            }

                            {/* {showSubFolder && <>{!module['expansionPack'] && <button className="td250 fs0-75rem pen bg5 c6 br5px fw600 px0-5rem py0-5rem"></button>Hide Subfolders</button>}</>} */}
                        </div>
                        {module.type === "business-audit" ? (
                            <div className="toggleHeight cp">
                                <button className="mb0-5rem td250 fs0-75rem pen bg5 c6 br5px fw600 px0-5rem py0-5rem">Show Section</button>
                                <div className="oh dg" style={{ cursor: "auto", height: "0px" }}>
                                    <div></div>
                                    {jsx}
                                </div>
                            </div>)
                            : <div className="dg">{jsx}</div>}
                    </div>
                );
            })
        }
        {((user['role'] == 'Guest' || !user.firstName) && module['type'] == `two-minute-test-${company['testType']}`) &&
            <div className="maw400px mxa my2rem df jcc aic fdc">
                <Button
                    btnType="warning"
                    text="Next"
                    disabled={(module?.['stats']?.['completionPercent'] != 100)}
                    customClassName="df jcc aic"
                    onClick={() => openKPI()}
                />
            </div>
        }
    </>
}
